import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import { MultiSelect } from 'react-multi-select-component';
import { TankPlanFilter } from 'src/enums/stowage/tankPlanFilter';
import { MultiSelectWrapper } from './SelectTankPlanFilter.style';

const tankPlanFilterList = [
    new Option('FOSFA accepted', TankPlanFilter.FosfaAccepted.toString()),
    new Option('Not FOSFA banned', TankPlanFilter.NotFosfaBanned.toString()),
    new Option('NIOP1 accepted', TankPlanFilter.Niop1Accepted.toString()),
    new Option('NIOP2 accepted', TankPlanFilter.Niop2Accepted.toString()),
    new Option('EU accepted', TankPlanFilter.EuAccepted.toString()),
];

const SelectTankPlanFilterComponent: React.FC = () => {
    const { selectedTankPlanFilters, setSelectedTankPlanFilters } = useStowageStore();

    const onChange = (e: HTMLOptionElement[]) => {
        setSelectedTankPlanFilters(e.map((o) => parseInt(o.value)));
    };

    const mapSelectedTankPlanFilters = (): HTMLOptionElement[] => {
        return tankPlanFilterList.filter((o) => selectedTankPlanFilters.includes(parseInt(o.value)));
    };

    return (
        <MultiSelectWrapper>
            <MultiSelect
                options={tankPlanFilterList}
                value={mapSelectedTankPlanFilters()}
                onChange={onChange}
                disableSearch={true}
                hasSelectAll={false}
                labelledBy="Filters"
                overrideStrings={{
                    selectSomeItems: 'Select filters',
                }}
            />
        </MultiSelectWrapper>
    );
};

export default SelectTankPlanFilterComponent;
